<template>

  <footer class="footer">

    <div class="container">

      <div class="footer-grid">

        <section>

          <img
              src="@/assets/images/logo.png"
              class="logo"
          >

          <p>

            مرجع اخبار، نتایج زنده، جدول لیگ‌ها و مسابقات فوتبال.

          </p>

        </section>

        <section>

          <h3>دسترسی سریع</h3>

          <router-link to="/">
            خانه
          </router-link>

          <router-link to="/news">
            اخبار
          </router-link>

          <router-link to="/matches">
            مسابقات
          </router-link>

          <router-link to="/competitions">
            لیگ‌ها
          </router-link>

        </section>

        <section>

          <h3>ضربه آزاد</h3>

          <router-link to="/about">
            درباره ما
          </router-link>

          <router-link to="/contact">
            تماس با ما
          </router-link>

          <router-link to="/privacy">
            حریم خصوصی
          </router-link>

          <router-link to="/ads">
            تبلیغات
          </router-link>

          <router-link to="/site-health" style="color: #10b981;">
            ● سلامت سایت و سئو
          </router-link>

        </section>

      </div>

      <div class="copyright">

        © 2026 ZarbeAzad.ir

      </div>

    </div>

  </footer>

</template>

<script>

export default {

  name:"AppFooter"

}

</script>

<style scoped lang="scss">

.footer {
  margin-top: 64px;
  background: #0f172a;
  color: #fff;
  width: 100%;
}

.container {
  width: 70%;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  gap: 40px;
  padding: 48px 0;
}

.logo {
  width: 170px;
  margin-bottom: 16px;
}

h3 {
  margin-bottom: 16px;
}

a {
  display: block;
  color: #cbd5e1;
  text-decoration: none;
  margin-bottom: 12px;
}

p {
  color: #cbd5e1;
  line-height: 1.9;
}

.copyright {
  border-top: 1px solid rgba(255,255,255,.08);
  padding: 20px 0;
  text-align: center;
  color: #94a3b8;
}

@media (min-width: 768px) {

  .footer-grid {
    grid-template-columns: 2fr 1fr 1fr;
  }

}

@media (max-width: 767px) {

  .footer {
    margin-top: 40px;
  }

  .container {
    width: 100%;
    padding: 0 20px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 35px 0;
  }

  .logo {
    width: 140px;
  }

  h3 {
    font-size: 16px;
  }

  .copyright {
    font-size: 13px;
    padding: 16px 0;
  }

}

</style>